
export const styles = theme => ({
  paperItem: {
    textAlign: "center",
    padding: 20,
    minHeight: 400,
  },
  icon: {
    width: "100%",
  },
  paperItemPlx: {
    transform: "translateY(300px)"
  }
});


export const item01Anim = ({viewHeight}) => ([
  {
    start: viewHeight * 1.4,
    end: viewHeight * 1.55,
    properties: [
      {
        startValue: 300,
        endValue: 0,
        property: "translateY",
      },
    ],
  },
]);


export const item02Anim = ({viewHeight}) => ([
  {
    start: viewHeight * 1.55,
    end: viewHeight * 1.7,
    properties: [
      {
        startValue: 300,
        endValue: 0,
        property: "translateY",
      },
    ],
  },
]);


export const item03Anim = ({viewHeight}) => ([
  {
    start: viewHeight * 1.7,
    end: viewHeight * 1.85,
    properties: [
      {
        startValue: 300,
        endValue: 0,
        property: "translateY",
      },
    ],
  },
]);


export const item04Anim = ({viewHeight}) => ([
  {
    start: viewHeight * 1.85,
    end: viewHeight * 2,
    properties: [
      {
        startValue: 300,
        endValue: 0,
        property: "translateY",
      },
    ],
  },
]);

